import colors from '../assets/styles/_colors.scss';

export const colorsExpenses = [
  colors.colorYellow,
  colors.colorPink,
  colors.colorPinkDeep,
  colors.colorBlueLight,
  colors.colorBlue,
  colors.colorAccent,
  colors.colorGreenLight,
  colors.colorGreen,
  colors.colorGreenDeep,
  colors.colorRed,
  colors.colorBlueNotactive,
  colors.colorMainText,
  colors.colorAccent,
  colors.colorWhite,
  colors.colorGrey,
  colors.colorGreyLight,
];
